// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_qm-5";
export var filledCircle = "_qm-4";
export var historyEntry = "_qm-3";
export var messageSideLeft = "_qm-1";
export var messageSideRight = "_qm-2";
export var orderTrackingCarouselWrapper = "_qm-6";
export var orderTrackingInfoContainer = "_qm-0";